import React from 'react';
import { connect } from 'react-redux';
import { verifyCCAForOfc } from 'hb-redux-store/feature/login/login.action';

const OrderForCustomer = props => {
  const { cuid: userUUID, ccid: ccaUUID, token: ccaToken } = props.match.params;
  const { orderForCustomerMessage: message } = props;
  let displayMessage = message || 'Please wait. Your request is under process.';
  const invalidData = !userUUID || !ccaUUID || !ccaToken;
  if (invalidData) {
    displayMessage = 'Invalid data. Your request cannot be processed.';
  }
  React.useEffect(() => {
    if (!invalidData) {
      props.verifyCCAForOfc({ userUUID, ccaUUID, ccaToken });
    }
  }, []);

  return (
    <div className="ofc">
      <div className="ofc--processing">
        <img src="https://cdn1.iconfinder.com/data/icons/business-management-and-growth-17/64/862-512.png" />
      </div>
      <div
        className={`ofc--message std-margin-tb ${
          message ? 'ofc--message--error' : ''
        }`}
      >
        {displayMessage}
      </div>
    </div>
  );
};

const mapStateToProps = ({ loginReducer }) => ({
  orderForCustomerMessage: loginReducer.orderForCustomerMessage,
});
const mapDispatchToProps = {
  verifyCCAForOfc,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderForCustomer);
